import { useEditorStore } from "@/store";
import type { SectionId } from "@/types/editor";
import { RootSection } from "./RootSection";
import { LayersSection } from "./LayersSection";
import { SourcesSection } from "./SourcesSection";
import { EnvironmentSection } from "./EnvironmentSection";
import { AssetsSection } from "./AssetsSection";

const SECTIONS: { id: SectionId; label: string; icon: string }[] = [
  { id: "root", label: "Map", icon: "⚙" },
  { id: "sources", label: "Sources", icon: "◉" },
  { id: "layers", label: "Layers", icon: "◧" },
  { id: "environment", label: "Environment", icon: "☀" },
  { id: "assets", label: "Assets", icon: "⬡" },
];

export function SectionsPanel() {
  const activeSection = useEditorStore((s) => s.activeSection);
  const setActiveSection = useEditorStore((s) => s.setActiveSection);

  return (
    <div className="flex h-full overflow-hidden">
      {/* Sidebar nav */}
      <nav className="flex w-20 shrink-0 flex-col border-r border-border-subtle bg-surface-sunken">
        {SECTIONS.map((section) => (
          <button
            key={section.id}
            type="button"
            onClick={() => setActiveSection(section.id)}
            className={`flex flex-col items-center gap-0.5 px-2 py-2.5 text-center transition-colors ${
              activeSection === section.id
                ? "bg-accent-muted text-accent"
                : "text-text-muted hover:bg-surface-base hover:text-text-secondary"
            }`}
          >
            <span className="text-base">{section.icon}</span>
            <span className="text-[10px] font-medium">{section.label}</span>
          </button>
        ))}
      </nav>

      {/* Section content */}
      <div className="flex-1 overflow-y-auto px-4 py-3">
        {activeSection === "root" && <RootSection />}
        {activeSection === "sources" && <SourcesSection />}
        {activeSection === "layers" && <LayersSection />}
        {activeSection === "environment" && <EnvironmentSection />}
        {activeSection === "assets" && <AssetsSection />}
      </div>
    </div>
  );
}
